var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeFacebookOutline = function SvgCassiopeiaBadgeFacebookOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.858,
    height: 50,
    viewBox: "0 0 10.546 13.229",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.034 40.845a141.49 141.49 0 0 0-132.852 98.068l176.282 176.282a141.49 141.49 0 0 0 98.05-132.852 141.49 141.49 0 0 0-141.48-141.498Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.501961,
      stroke: "#000",
      strokeWidth: 7.1104,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "21.3312,7.1104",
      strokeDashoffset: 7.82144,
      strokeOpacity: 0.501961
    },
    transform: "matrix(.03727 0 0 .03727 -.48 -.02)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeFacebookOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-facebook-outline.8ec0735df3a72e3705c1bdbcbbfa4338.svg";